<app-header sectionName="Settings">
  @if (canEdit) {
  @if (form.dirty) {
  <span class="unsaved muted">Unsaved changes</span>
  <button mat-button (click)="discard()" [disabled]="saving">Discard</button>
  }
  <button mat-flat-button (click)="save()" [disabled]="!form.dirty || form.invalid || saving || loading">
    <mat-icon>save</mat-icon>
    Save
  </button>
  }
</app-header>

@if (loading || saving || resetting) {
<mat-progress-bar class="top-progress" mode="indeterminate"></mat-progress-bar>
}

<div class="page page-narrow">
  <form [formGroup]="form" (ngSubmit)="save()">
    @for (group of groups; track group.title) {
    <section class="app-panel settings-group">
      <h2 class="section-title">
        <mat-icon>{{ group.icon }}</mat-icon>
        {{ group.title }}
      </h2>
      <div class="field-grid">
        @for (f of group.fields; track f.key) {
        <mat-form-field appearance="outline">
          <mat-label>{{ f.label }}</mat-label>
          <input matInput type="number" [min]="f.min" [step]="f.step ?? 1" [formControlName]="f.key" />
          @if (f.suffix) {
          <span matTextSuffix class="muted">{{ f.suffix }}</span>
          }
          @if (f.hint) {
          <mat-hint>{{ f.hint }}</mat-hint>
          }
          @if (form.get(f.key)?.hasError('min')) {
          <mat-error>Must be at least {{ f.min }}</mat-error>
          }
          @if (form.get(f.key)?.hasError('required')) {
          <mat-error>Required</mat-error>
          }
        </mat-form-field>
        }
      </div>
      @if (groupError(group); as error) {
      <p class="group-error">{{ error }}</p>
      }
    </section>
    }
  </form>

  <app-telegram-alerts [canEdit]="canEdit"></app-telegram-alerts>

  <section class="app-panel danger-zone">
    <div>
      <h2 class="section-title danger-title">
        <mat-icon>warning</mat-icon>
        Danger zone
      </h2>
      <p class="muted">Reset every setting above to its default value. Telegram alert switches are kept.</p>
    </div>
    <button mat-stroked-button class="danger-btn" (click)="resetToDefaults()" [disabled]="!canEdit || resetting || loading">
      <mat-icon>restart_alt</mat-icon>
      Reset to defaults
    </button>
  </section>
</div>
